import React from "react";
import HeroSection from "@/components/HeroSection";
import ProgramsPage from "./ProgramsPage";
import TrainingsPage from "./TrainingsPage";
import ReviewsPage from "./ReviewsPage";
import ContactPage from "./ContactPage";

/**
 * Single-page composition: the user wants ALL page content visible on the
 * home page while still keeping the standalone routes functional. Each
 * imported page is self-contained (own data-fetching + testids), so we just
 * stack them below the hero.
 */
export default function HomePage() {
    return (
        <div data-testid="home-page">
            <HeroSection />

            <section id="programs" data-testid="home-programs-full">
                <ProgramsPage />
            </section>

            <section id="trainings" data-testid="home-trainings-full">
                <TrainingsPage />
            </section>

            <section id="reviews" data-testid="home-reviews-full">
                <ReviewsPage />
            </section>

            <section id="contact" data-testid="home-contact-full">
                <ContactPage />
            </section>
        </div>
    );
}
